import React from 'react'
import { ClassroomEnvProvider } from '@components/ClassroomEnv'
import { Classroom as ClassroomConstants } from '@constants'

import { SketchpadStateProvider } from './useSketchpadState'
import { useAuth } from '@hooks'
import { useParams } from 'react-router-dom'

const SketchpadProvider = ({ children }) => {
  const { profile } = useAuth()
  const { id } = useParams()

  return (
    <ClassroomEnvProvider
      env={ClassroomConstants.ENV.SKETCHPAD}
      id={id ?? profile.id}
    >
      <SketchpadStateProvider>{children}</SketchpadStateProvider>
    </ClassroomEnvProvider>
  )
}

export { SketchpadProvider }
export {
  useSketchpadState,
  useSketchpadStateDispatch
} from './useSketchpadState'
